import { useState, useMemo, useEffect, useCallback } from "react";
function useImageSelectQuiz({
  quizId,
  quiz,
  onSolve,
  solveResult,
  showReallyTrue = false,
  isViewSolved = false,
  initialAnswers: initialAnswersProp,
  onAnswerChange
}) {
  const [startTime] = useState(() => Date.now());
  const [isShowingCorrectAnswers, setIsShowingCorrectAnswers] = useState(false);
  const isSolved = solveResult !== null && solveResult !== void 0;
  const shouldShowCorrectAnswers = showReallyTrue || isShowingCorrectAnswers;
  const computedInitialKeys = useMemo(() => {
    if (initialAnswersProp && initialAnswersProp.length > 0) {
      return new Set(initialAnswersProp);
    }
    if (isViewSolved && (solveResult == null ? void 0 : solveResult.correctAnswers)) {
      return new Set(solveResult.correctAnswers);
    }
    return /* @__PURE__ */ new Set();
  }, [isViewSolved, solveResult, initialAnswersProp]);
  const [selectedKeys, setSelectedKeys] = useState(computedInitialKeys);
  useEffect(() => {
    setSelectedKeys(computedInitialKeys);
  }, [computedInitialKeys]);
  useEffect(() => {
    onAnswerChange == null ? void 0 : onAnswerChange(Array.from(selectedKeys));
  }, [selectedKeys, onAnswerChange]);
  const canSubmit = selectedKeys.size > 0;
  const handleToggle = useCallback((key) => {
    if (isSolved || isViewSolved) return;
    setSelectedKeys((prev) => {
      const next = new Set(prev);
      if (next.has(key)) {
        next.delete(key);
      } else {
        next.add(key);
      }
      return next;
    });
  }, [isSolved, isViewSolved]);
  const handleSubmit = useCallback(() => {
    if (!canSubmit || isSolved) return;
    const elapsedTime = Date.now() - startTime;
    const answersArray = Array.from(selectedKeys);
    onSolve == null ? void 0 : onSolve(quizId, answersArray, quiz.vars, elapsedTime);
  }, [selectedKeys, canSubmit, isSolved, startTime, onSolve, quizId, quiz.vars]);
  return {
    selectedKeys,
    isSolved,
    canSubmit,
    shouldShowCorrectAnswers,
    isShowingCorrectAnswers,
    setIsShowingCorrectAnswers,
    handleToggle,
    handleSubmit,
    quiz,
    quizId,
    solveResult,
    isViewSolved
  };
}
export {
  useImageSelectQuiz
};
//# sourceMappingURL=use-image-select-quiz.js.map
